import React from "react"
import { Box, Text, Image, Grid, Flex, Container } from "theme-ui"
import { useState, useEffect } from "react"
import { i18nContext } from "../context/i18nContext"
import Telmotor from "../images/telmotor-white.svg"
import TelmotorBlack from "../images/logo-telmotor-black.svg"
import { useColorMode } from "theme-ui"
import { color } from "framer-motion"
import XCelerator from "../images/xcelerator.png"

const PreFooter = ({ partner }) => {
  const colorMode = useColorMode()

  const [isDark, setIsDark] = useState(false)
  useEffect(() => {
    colorMode[0] === "dark" ? setIsDark(true) : setIsDark(false)
  }, [colorMode[0]])
  console.log(colorMode[0])

  console.log("isDark:", isDark, "colorMode:", colorMode)

  return (
    <Box sx={{ backgroundColor: "dark" }}>
      <Container sx={{ p: [3, 3, 3, 4], pb: "0px!important" }}>
        <i18nContext.Consumer>
          {t => (
            <Grid
              columns={[1, 1, "1fr 2fr"]}
              gap={[6, 6, 6, 10]}
              sx={{ my: 5 }}
            >
              <Flex sx={{ flexDirection: "column", gap: [5, 5, 3] }}>
                <Text sx={{ color: "light", width: "100%" }}>
                  {t.prefooter.body}
                </Text>
                <Flex
                  sx={{
                    flexDirection: ["column", "column", "row"],
                    gap: [4, 4, 3],
                    justifyContent: "space-between",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      aspectRatio: 1 / 1,
                      height: "60px",
                      width: "60px",
                      overflow: "hidden",
                    }}
                  >
                    <Image
                      sx={{
                        width: "100%",
                        height: "100%",
                      }}
                      src={XCelerator}
                    />
                  </Box>
                  <Text
                    as="p"
                    sx={{
                      fontSize: 3,
                      fontWeight: "bold",
                      color: "light",
                    }}
                  >
                    Partner Siemens Xcelerator
                  </Text>
                </Flex>
              </Flex>
              <Box>
                <Flex
                  sx={{
                    gap: [3, 3, 3],
                    flexDirection: ["column", "column", "row", "row"],
                    borderBottom: "2px solid",
                    borderColor: "light",

                    pb: [4, 4, 5],
                  }}
                >
                  <Text
                    sx={{
                      flex: "1 0 40%",
                      maxWidth: "40%",
                      color: "light",
                      textTransform: "uppercase",
                      fontFamily: "mono",
                      fontWeight: 400,
                    }}
                    as="h4"
                  >
                    {t.prefooter.project}
                  </Text>
                  <Box sx={{ flexBasis: "1 0 60%" }}>
                    {isDark ? (
                      <Image
                        sx={{ width: ["200px"], height: "60px", fill: "light" }}
                        src={TelmotorBlack}
                      />
                    ) : (
                      <Image
                        sx={{ width: ["200px"], height: "60px", fill: "light" }}
                        src={Telmotor}
                      />
                    )}
                  </Box>
                </Flex>
                <Flex
                  sx={{
                    gap: [5, 5, 5, 3],
                    py: [4, 4, 4, 5],
                    flexDirection: ["column", "column", "row", "row"],
                  }}
                >
                  <Text
                    sx={{
                      flex: "1 0 40%",
                      maxWidth: "40%",
                      color: "light",
                      textTransform: "uppercase",
                      fontWeight: 400,
                      fontFamily: "mono",
                    }}
                    as="h4"
                  >
                    {t.prefooter.partner}
                  </Text>

                  <Flex
                    sx={{
                      gap: 5,

                      alignContent: "flex-end",
                      alignItems: "flex-end",
                    }}
                  >
                    {partner.nodes.map((partnerItem, index) => (
                      <Image
                        sx={{}}
                        key={index}
                        src={
                          isDark
                            ? partnerItem.imageBlack.url
                            : partnerItem.image.url
                        }
                        alt={partnerItem.title}
                      />
                    ))}
                  </Flex>
                </Flex>
              </Box>
            </Grid>
          )}
        </i18nContext.Consumer>
      </Container>
    </Box>
  )
}

export default PreFooter
